<template>
  <v-container fluid>
    <v-layout class="mb-5" align-start justify-left>
      <v-flex xs12 sm12>
        <v-card>
          <v-card-title>
            Categories
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :loading="state.isLoading()"
            :headers="headers"
            :items="categories"
            :items-per-page="50"
            :search="search"
          >
            <template v-slot:item.is_credit="{ item }">
              <div v-if="item.is_credit">
                <v-icon>check</v-icon>
              </div>
            </template>
            <template v-slot:item.show_in_report="{ item }">
              <div v-if="item.show_in_report">
                <v-icon>check</v-icon>
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <v-icon
                small
                class="mr-2"
                @click="editCategory(item)"
              >
                edit
              </v-icon>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <v-dialog v-model="showCreateDailog" max-width="600px">
        <template v-slot:activator="{ on }">
        </template>
        <create-category 
          @created="onCategoryCreated"
          @saved="onCategorySaved"
          :category="categoryDraft"
          v-model="showCreateDailog"></create-category>
      </v-dialog>
      <v-fab-transition>
        <v-btn
          @click="showDailog"
          color="pink"
          dark
          fixed bottom right fab
        ><v-icon>add</v-icon></v-btn>
      </v-fab-transition>
    </v-layout>
  </v-container>
</template>
<script>
import { DataState } from "@/state"
import { Category } from "@/models/category"
import CreateCategory from "@/components/CreateCategory";
import CategoryItem from "@/components/CategoryItem";
export default {
  components: {
    CreateCategory: CreateCategory,
    CategoryItem: CategoryItem
  },
  data() {
    return {
      headers: [
        {text: 'Name', value: 'name'},
        {text: 'Parent', value: 'parent'},
        {text: 'Credit', value: 'is_credit', width:20},
        {text: 'Report', value: 'show_in_report', width:20},
        {text: 'Actions', value: 'action', sortable: false, width:80 },
      ],
      search: '',
      categoryDraft: Category.newEmpty(),
      categories: [],
      showCreateDailog: false,
      state: DataState.newLoading(),
      createState: DataState.newLoading(),
    };
  },

  mounted () {
    this.onLoaded()
  },

  methods: {
    onLoaded () {
      this.state.changeToLoading()
      Category.list(true).then((response) => {
        this.categories = response
        this.state.changeToLoaded()
      }).catch((error) => {
        this.state.changeToError(error)
      })
    },

    showDailog() {
      this.categoryDraft = Category.newEmpty()
      this.showCreateDailog = true
    },

    editCategory(category) {
      this.categoryDraft = category
      this.showCreateDailog = true
    },

    onCategoryCreated(category) {
      this.categories.push(category)
      this.showCreateDailog = false
    },

    onCategorySaved(category) {
      this.categoryDraft = Category.newEmpty()
      this.showCreateDailog = false
    }
  }
};
</script>
